import useSelectOrgUnitData from "@usas/ui-web/state/selectOrgUnit/UseSelectOrgUnitData";

const ROUTE_NAME = 'TOP_TIMES_LSC_SEARCH';

const useTopTimesLscSearch = () => {
  const { selectOrgUnitState } = useSelectOrgUnitData();

  return {
    orgUnitId: selectOrgUnitState.orgUnitId,
    orgUnitName: selectOrgUnitState.orgUnitName,
    routeName: ROUTE_NAME
  };
};

export default useTopTimesLscSearch;